import { Redirect } from "react-router";
import { useAuthState } from "../../utilities/contexts/auth-state-context";
import { useState } from "react";
import "./super-admin-tools-page.styles.scss";
import { SuperAdminTool } from "../../models/enumerations/super-admin-tool";
import ViewWellnessProgramContentTool from "./view-wellness-program-content-tool";
import DetermineCorrectiveProgramTool from "./determine-corrective-program-tool";
import GeneratePartnerApiKeyTool from "./generate-partner-api-key-tool";
import ExportProductionUsersToDemoTool from "./export-production-users-to-demo-tool";
import UploadMockDemoDataTool from "./upload-mock-demo-data-tool";
import ManageDemoOrganizationsTool from "./manage-demo-organizations-tool";
import MskRealAveragesTool from "./msk-real-averages-tool";
import MskLiteTool from "./msk-lite-tool";
import RiskSummaryTool from "./risk-summary-tool";
import MskSummaryTool from "./msk-summary-tool";
import PartialMskSummaryTool from "./partial-msk-summary-tool";
import RegeneratePartialMskSummaryTool from "./regenerate-partial-msk-summary-tool";
import ApiKeyUsageTool from "./api-key-usage-tool";
import DataExportReportTool from "./data-export-report-tool";
import TestLoggingTool from "./test-logging-tool";
import NormalizeUserEmailsTool from "./normalize-user-emails-tool";
import FixInvalidBirthdatesTool from "./fix-invalid-birthdates-tool";



const COMPONENT_CLASS = "c-super-admin-tools";

const SuperAdminToolsPage: React.FC = () => {
    const { state } = useAuthState();
    const [selectedTool, setSelectedTool] = useState<SuperAdminTool | "">("");

    if (!state.user) {
        throw new Error("You must be a super admin");
    }

    if (!state.user.isSuperAdmin) {
        return <Redirect to="/" />;
    }

    return (
        <div className={COMPONENT_CLASS}>

            {/* Tool selector */}
            <div className={`${COMPONENT_CLASS}__field`}>
                <label>Tool Selector</label>
                <select
                    value={selectedTool}
                    onChange={(e) =>
                        setSelectedTool(e.target.value as SuperAdminTool)
                    }
                >
                    <option value="">Select tool</option>
                    <option value={SuperAdminTool.CorrectiveProgramArticles}>
                        View Wellness Program Content
                    </option>
                    <option value={SuperAdminTool.DetermineCorrectiveProgram}>
                        Determine Corrective Program
                    </option>
                    <option value={SuperAdminTool.GeneratePartnerApiKey}>
                        Generate Partner API Key
                    </option>
                    <option value={SuperAdminTool.UploadMockDemoData}>
                        Upload Mock Demo Data
                    </option>
                    <option value={SuperAdminTool.ExportProductionUsersToDemo}>
                        Export Production Users to Demo
                    </option>
                    <option value={SuperAdminTool.ManageDemoOrganizations}>
                        Manage Demo Organizations
                    </option>
                    <option value={SuperAdminTool.MskRealAverages}>
                        MSK Real Averages
                    </option>
                    <option value={SuperAdminTool.MskLiteDemo}>
                        MSK Lite Demo
                    </option>
                    <option value={SuperAdminTool.AiRiskSummary}>
                        AI Risk Summary
                    </option>
                    <option value={SuperAdminTool.AiMskSummary}>
                        AI MSK Summary
                    </option>
                    <option value={SuperAdminTool.AiPartialMskSummary}>
                        AI Partial MSK Summary
                    </option>
                    <option value={SuperAdminTool.AiRegeneratePartialMskSummary}>
                        Regenerate Partial MSK Summary
                    </option>
                    <option value={SuperAdminTool.ApiKeyUsage}>
                        API Key Usage
                    </option>
                    <option value={SuperAdminTool.DataExportReport}>
                        Data Export Report
                    </option>
                    <option value={SuperAdminTool.TestLogging}>
                        Test Logging
                    </option>
                    <option value={SuperAdminTool.NormalizeUserEmails}>
                        Normalize User Emails
                    </option>
                    <option value={SuperAdminTool.FixInvalidBirthdates}>
                        Fix Invalid Birthdates
                    </option>
                </select>
            </div>

            {/* Tool renderer */}
            {selectedTool === SuperAdminTool.CorrectiveProgramArticles && (
                <ViewWellnessProgramContentTool />
            )}

            {selectedTool === SuperAdminTool.DetermineCorrectiveProgram && (
                <DetermineCorrectiveProgramTool />
            )}
            {selectedTool === SuperAdminTool.GeneratePartnerApiKey && (
                <GeneratePartnerApiKeyTool />
            )}
            {selectedTool === SuperAdminTool.UploadMockDemoData && (
                <UploadMockDemoDataTool />
            )}
            {selectedTool === SuperAdminTool.ExportProductionUsersToDemo && (
                <ExportProductionUsersToDemoTool />
            )}
            {selectedTool === SuperAdminTool.ManageDemoOrganizations && (
                <ManageDemoOrganizationsTool />
            )}
            {selectedTool === SuperAdminTool.MskRealAverages && (
                <MskRealAveragesTool />
            )}
            {selectedTool === SuperAdminTool.MskLiteDemo && (
                <MskLiteTool />
            )}
            {selectedTool === SuperAdminTool.AiRiskSummary && (
                <RiskSummaryTool />
            )}
            {selectedTool === SuperAdminTool.AiMskSummary && (
                <MskSummaryTool />
            )}
            {selectedTool === SuperAdminTool.AiPartialMskSummary && (
                <PartialMskSummaryTool />
            )}
            {selectedTool === SuperAdminTool.AiRegeneratePartialMskSummary && (
                <RegeneratePartialMskSummaryTool />
            )}
            {selectedTool === SuperAdminTool.ApiKeyUsage && (
                <ApiKeyUsageTool />
            )}
            {selectedTool === SuperAdminTool.DataExportReport && (
                <DataExportReportTool />
            )}
            {selectedTool === SuperAdminTool.TestLogging && (
                <TestLoggingTool />
            )}
            {selectedTool === SuperAdminTool.NormalizeUserEmails && (
                <NormalizeUserEmailsTool />
            )}
            {selectedTool === SuperAdminTool.FixInvalidBirthdates && (
                <FixInvalidBirthdatesTool />
            )}

        </div>
    );
};

export default SuperAdminToolsPage;
